import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const DisplayTokenElement = ({
    token,
    minAmount,
    maxAmount,
    odds,
    calcTotalTokenOutcomesOdds,
    guaranteed,
}) => {
    let tokenValue =
        token !== null && token !== undefined
            ? parseFloat(token.split(' ')[0]).toString()
            : null
    const minValue =
        minAmount !== null && minAmount !== undefined
            ? parseFloat(minAmount.split(' ')[0]).toString()
            : null
    const maxValue =
        maxAmount !== null && maxAmount !== undefined
            ? parseFloat(maxAmount.split(' ')[0]).toString()
            : null

    if (maxValue === minValue && !token) {
        tokenValue = maxValue
    }

    const tokenName =
        token !== null && token !== undefined
            ? token.split(' ')[1]
            : minAmount !== null && minAmount !== undefined
            ? minAmount.split(' ')[1]
            : null

    const { t } = useTranslation('common')

    return (
        <div>
            <div className="border dark:!border-paperl border-zinc-200 rounded-md shadow-md h-84 w-46 bg-white dark:!bg-black relative">
                {guaranteed ? (
                    <Tooltip
                        title={`The chance that the user will get this Token is 100%`}
                    >
                        <div className="absolute z-2 top-2 left-2 bg-white dark:!bg-black font-medium rounded-lg px-2">
                            100%
                        </div>
                    </Tooltip>
                ) : odds ? (
                    <Tooltip
                        title={t('craft.chance_that_the_user_will_get_token', {
                            x: (odds / calcTotalTokenOutcomesOdds()) * 100,
                        })}
                    >
                        <div className="absolute z-2 top-2 left-2 bg-white dark:!bg-black font-medium rounded-lg px-2">
                            {parseInt(
                                (odds / calcTotalTokenOutcomesOdds()) * 100,
                            )}
                            %
                        </div>
                    </Tooltip>
                ) : null}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-center">
                    {tokenValue !== null ? (
                        <div
                            className={
                                tokenValue.length <= 8
                                    ? 'text-2xl'
                                    : tokenValue.length <= 16
                                    ? 'text-lg'
                                    : ''
                            }
                        >
                            {tokenValue}
                        </div>
                    ) : minValue !== null && maxValue !== null ? (
                        <div>
                            <div className="italic text-sm text-zinc-400">
                                from
                            </div>
                            <div
                                className={
                                    minValue.length <= 8
                                        ? 'text-2xl'
                                        : minValue.length <= 16
                                        ? 'text-lg'
                                        : ''
                                }
                            >
                                {minValue}
                            </div>
                            <div className="italic text-sm text-zinc-400">
                                up to
                            </div>
                            <div
                                className={
                                    maxValue.length <= 8
                                        ? 'text-2xl'
                                        : maxValue.length <= 16
                                        ? 'text-lg'
                                        : ''
                                }
                            >
                                {maxValue}
                            </div>
                        </div>
                    ) : (
                        <i>invalid token</i>
                    )}
                    <div className="text-2xl">{tokenName}</div>
                </div>
            </div>
        </div>
    )
}
